/* eslint-disable react/prop-types */
import PropTypes from 'prop-types';
import React, { useRef, useState, useEffect, useMemo, useCallback } from 'react';
import { CallWithAuth } from '../../../action/apiActions';
import {
  EDIT_CATEGORY,
  EDIT_IDENTIFIER,
  EDIT_QUESTIONBANK,
  EDIT_SUBJECT_TAG,
  GET_FREE_TAG,
  GET_SUBJECT_TAG,
  GET_QUESTIONBANK_METATAG_SUGGESTIONS,
  LOD,
} from '../../../action/apiPath';
import { debounce } from '../debounce';
import style from '../../../assets/styles/modalStyle.module.css';
import { useDispatch } from 'react-redux';
import {
  Get_All_Identifier,
  Get_All_LOD,
  Get_All_Question_bank,
  Get_All_Subject_pipeline,
  Get_Category_Pagination,
} from '../../../redux/action';
import { useToast } from '../../molecule/common/Toast';

const MastersEditModal = ({ setSort, modal, closeModal, type, data, limit, currentPage, categoryKey }) => {
  const dispatch = useDispatch();
  // ________________ Initialization of FREE TAG ________________
  const [newFreeTag, setnewFreeTag] = useState([]);
  const [multiselectedfreeTag, setmultiSelectedfreeTag] = useState([]);
  const [multifreeTaginput, setmultifreeTaginput] = useState('');
  const [multifreeTag, setmultifreeTag] = useState([]);
  const [multifreeTagStatus, setmultifreeTagStatus] = useState(false);
  const [newfreeTags, setnewfreeTags] = useState([]);
  const [newfreeTagStatus, setnewfreeTagStatus] = useState(false);
  const organizationId = localStorage.getItem('selectedOrgId');
  // CALL GET API FOR getting TAGS
  const TagFreeMultiple = async (e) => {
    setmultifreeTaginput(e);
    if (e.length > 2) {
      const data = await CallWithAuth('GET', GET_FREE_TAG + '?keyword=' + e);
      if (data.status && data.res.status === 200) {
        if (data.res.data.length > 0) {
          setmultifreeTag(data.res.data);
          setnewfreeTagStatus(false);
          setmultifreeTagStatus(true);
        } else {
          setnewfreeTags([e]);
          setmultifreeTagStatus(false);
          setnewfreeTagStatus(true);
        }
      }
    } else {
      setmultifreeTagStatus(false);
    }
  };

  // select tags from options
  const selectFreeTag = (e) => {
    const data = [...multiselectedfreeTag, e].filter(
      (value, index, self) => index === self.findIndex((t) => t.id === value.id)
    );
    setmultiSelectedfreeTag(data);
    setmultifreeTagStatus(false);
    setmultifreeTaginput('');
  };

  const selectnewFreeTag = (e) => {
    const data = [...newFreeTag, e].filter((value, index, self) => index === self.findIndex((t) => t === value));
    setnewFreeTag(data);
    setnewfreeTagStatus(false);
    setmultifreeTaginput('');
  };

  const CancelButton = () => {
    setnewFreeTag([]);
    setmultiSelectedfreeTag([]);
  };

  // _________ STATE INITIALIZATION subject tag_________
  const [subjectTag, setSubjectTag] = useState([]);
  const [selectedPrimaryTagStatus, setSelectedPrimaryTagStatus] = useState(false);
  const [subjectTagStatus, setSubjectTagStatus] = useState(false);
  const [selectedPrimaryTag, setSelectedPrimaryTag] = useState(null);

  const TagSubject = async (e) => {
    if (e.length > 2) {
      const data = await CallWithAuth('GET', GET_SUBJECT_TAG + 'fetch-subject/' + organizationId + '/?subject=' + e);
      if (data.status && data.res.status === 200) {
        setSubjectTag(data.res.data);
        if (data.res.data.length > 0) {
          setSubjectTagStatus(true);
        } else {
          setSubjectTagStatus(false);
        }
      }
    } else {
      setSubjectTagStatus(false);
    }
  };

  // select tags from options
  const selectPrimaryTag = (e) => {
    setSelectedPrimaryTag(e);
    setSelectedPrimaryTagStatus(true);
    setSubjectTagStatus(false);
  };

  // _________ STATE INITIALIZATION Topic tag_________
  const [TopicTag, setTopicTag] = useState([]);
  const [selectedTopicTagStatus, setSelectedTopicTagStatus] = useState(false);
  const [TopicTagStatus, setTopicTagStatus] = useState(false);
  const [selectedTopicTag, setSelectedTopicTag] = useState(null);

  const TagTopic = async (e) => {
    if (e.length > 2) {
      const data = await CallWithAuth('GET', GET_SUBJECT_TAG + 'fetch-topic/' + organizationId + '/?topic=' + e);
      if (data.status && data.res.status === 200) {
        setTopicTag(data.res.data);
        if (data.res.data.length > 0) {
          setTopicTagStatus(true);
        } else {
          setTopicTagStatus(false);
        }
      }
    } else {
      setTopicTagStatus(false);
    }
  };

  // select tags from options
  const selectTopicTag = (e) => {
    setSelectedTopicTag(e);
    setSelectedTopicTagStatus(true);
    setTopicTagStatus(false);
  };

  // _________ STATE INITIALIZATION area tag_________
  const [AreaTag, setAreaTag] = useState([]);
  const [selectedAreaTagStatus, setSelectedAreaTagStatus] = useState(false);
  const [AreaTagStatus, setAreaTagStatus] = useState(false);
  const [selectedAreaTag, setSelectedAreaTag] = useState(null);

  const TagArea = async (e) => {
    if (e.length > 2) {
      const data = await CallWithAuth('GET', GET_SUBJECT_TAG + 'fetch-area/' + organizationId + '/?area=' + e);
      if (data.status && data.res.status === 200) {
        setAreaTag(data.res.data);
        if (data.res.data.length > 0) {
          setAreaTagStatus(true);
        } else {
          setAreaTagStatus(false);
        }
      }
    } else {
      setAreaTagStatus(false);
    }
  };

  // select tags from options
  const selectAreaTag = (e) => {
    setSelectedAreaTag(e);
    setSelectedAreaTagStatus(true);
    setAreaTagStatus(false);
  };

  // ________________ Initialization of SUBTOIC TAG ________________
  const [multiselectedSubTopicTag, setmultiSelectedSubTopicTag] = useState([]);
  const [multiSubTopicTaginput, setmultiSubTopicTaginput] = useState('');
  const [multiSubTopicTag, setmultiSubTopicTag] = useState([]);
  const [multiSubTopicTagStatus, setmultiSubTopicTagStatus] = useState(false);

  // CALL GET API FOR getting TAGS
  const TagSubTopicMultiple = async (e) => {
    setmultiSubTopicTaginput(e);
    if (e.length > 2) {
      const data = await CallWithAuth('GET', GET_SUBJECT_TAG + 'fetch-subtopic/' + organizationId + '/?subtopic=' + e);
      if (data.status && data.res.status === 200) {
        if (data.res.data.length > 0) {
          setmultiSubTopicTag(data.res.data);
          setmultiSubTopicTagStatus(true);
        } else {
          setmultiSubTopicTagStatus(false);
        }
      }
    } else {
      setmultiSubTopicTagStatus(false);
    }
  };

  // select tags from options
  const selectSubTopicTag = (e) => {
    setmultiSelectedSubTopicTag((current) => [...current, e]);
    setmultiSubTopicTagStatus(false);
    setmultiSubTopicTaginput('');
  };

  const CancelButtonSubTopic = () => {
    // setnewSubTopicTag([])
    setmultiSelectedSubTopicTag([]);
  };

  const [descriptionSubTopic, setdescriptionSubTopic] = useState('');

  // ________________ Initialization of CATEGORY  ________________
  const [newCategoryName, setNewCategoryName] = useState('');
  const [newCategoryDescription, setNewCategoryDescription] = useState('');

  // ________________ Initialization of Identifier  ________________
  const [newIdentifierName, setNewIdentifierName] = useState('');
  const [newIdentifierDescription, setNewIdentifierDescription] = useState('');

  // ________________ Initialization of Question Bank  ________________
  const [newQuestionBankName, setNewQuestionBankName] = useState('');
  const [newQuestionBankDescription, setNewQuestionBankDescription] = useState('');
  const [questionBankLOFTStatus, setQuestionBankLOFTStatus] = useState(false);

  // ________________ Initialization of Metatags state ________________
  const [metatags, setMetatags] = useState([
    { key: '', value: '' },
    { key: '', value: '' },
  ]);
  const [activeKeyIndex, setActiveKeyIndex] = useState(null);
  const [keySuggestions, setKeySuggestions] = useState([]);
  const [activeValueIndex, setActiveValueIndex] = useState(null);
  const [valueSuggestions, setValueSuggestions] = useState([]);

  // Metatags handlers
  const handleAddMetatagRow = () => {
    setMetatags((prev) => [...prev, { key: '', value: '' }]);
  };

  const handleDeleteMetatagRow = (index) => {
    setMetatags((prev) => (prev.length > 1 ? prev.filter((_, i) => i !== index) : [{ key: '', value: '' }]));
  };

  const fetchKeySuggestions = async (index, val = '') => {
    setActiveKeyIndex(index);
    setActiveValueIndex(null);
    setValueSuggestions([]);
    const trimmed = (val || '').trim();
    if (!trimmed) {
      setKeySuggestions([]);
      return;
    }
    try {
      const res = await CallWithAuth(
        'GET',
        `${GET_QUESTIONBANK_METATAG_SUGGESTIONS}${organizationId}/?type=key&keyword=${encodeURIComponent(trimmed)}`
      );
      const list = res?.res?.data?.data || (Array.isArray(res?.res?.data) ? res.res.data : []);
      setKeySuggestions(Array.isArray(list) ? list : []);
    } catch (err) {
      setKeySuggestions([]);
    }
  };

  const fetchValueSuggestions = async (index, val = '') => {
    setActiveValueIndex(index);
    setActiveKeyIndex(null);
    setKeySuggestions([]);
    const trimmed = (val || '').trim();
    if (!trimmed) {
      setValueSuggestions([]);
      return;
    }
    try {
      const res = await CallWithAuth(
        'GET',
        `${GET_QUESTIONBANK_METATAG_SUGGESTIONS}${organizationId}/?type=value&keyword=${encodeURIComponent(trimmed)}`
      );
      const list = res?.res?.data?.data || (Array.isArray(res?.res?.data) ? res.res.data : []);
      setValueSuggestions(Array.isArray(list) ? list : []);
    } catch (err) {
      setValueSuggestions([]);
    }
  };

  const debouncedFetchKeySuggestions = useMemo(
    () =>
      debounce((index, val) => {
        fetchKeySuggestions(index, val);
      }, 300),
    [organizationId]
  );

  const debouncedFetchValueSuggestions = useMemo(
    () =>
      debounce((index, val) => {
        fetchValueSuggestions(index, val);
      }, 300),
    [organizationId]
  );

  const handleMetatagKeyChange = (index, val) => {
    setMetatags((prev) => prev.map((item, i) => (i === index ? { ...item, key: val } : item)));
    setActiveKeyIndex(index);
    debouncedFetchKeySuggestions(index, val);
  };

  const handleMetatagValueChange = (index, val) => {
    setMetatags((prev) => prev.map((item, i) => (i === index ? { ...item, value: val } : item)));
    setActiveValueIndex(index);
    debouncedFetchValueSuggestions(index, val);
  };

  const handleSelectKey = (index, selectedKey) => {
    setMetatags((prev) => prev.map((item, i) => (i === index ? { ...item, key: selectedKey } : item)));
    setActiveKeyIndex(null);
    setKeySuggestions([]);
  };

  const handleSelectValue = (index, selectedVal) => {
    setMetatags((prev) => prev.map((item, i) => (i === index ? { ...item, value: selectedVal } : item)));
    setActiveValueIndex(null);
    setValueSuggestions([]);
  };

  const handleKeyBlur = (index) => {
    setTimeout(() => {
      setActiveKeyIndex(null);
      setMetatags((prev) => {
        if (!prev[index]?.key) return prev;
        const trimmed = prev[index].key.trim();
        const match = keySuggestions.find((k) => k.toLowerCase() === trimmed.toLowerCase());
        if (match && match !== prev[index].key) {
          return prev.map((item, i) => (i === index ? { ...item, key: match } : item));
        }
        return prev;
      });
    }, 250);
  };

  const handleValueBlur = (index) => {
    setTimeout(() => {
      setActiveValueIndex(null);
      setMetatags((prev) => {
        if (!prev[index]?.value) return prev;
        const trimmed = prev[index].value.trim();
        const match = valueSuggestions.find((v) => v.toLowerCase() === trimmed.toLowerCase());
        if (match && match !== prev[index].value) {
          return prev.map((item, i) => (i === index ? { ...item, value: match } : item));
        }
        return prev;
      });
    }, 250);
  };

  // ________________ Initialization of LOD  ________________
  const toast = useToast();
  const [newLODName, setNewLODName] = useState('');

  // Function CALL for add
  const AddNew = async (id) => {
    if (type === 'Category') {
      const body = {
        name: newCategoryName,
        description: newCategoryDescription,
        free_tags: multiselectedfreeTag?.map((item) => item.id),
        new_free_tags: newFreeTag,
      };
      const data = await CallWithAuth('PATCH', EDIT_CATEGORY + id + '/update-category/', body);
      if (data.status) {
        if (toast) {
          toast.remove('all');
          toast.add(String(data.res.data.message), 'success');
        }
        closeModal();
        dispatch(Get_Category_Pagination(organizationId, '', '', limit, currentPage));
        setSort('');
      } else {
        const keys = Object.keys(data.res.data);

        if (keys.length > 0) {
          const firstErrorKey = keys[0];
          if (toast) {
            toast.remove('all');
            toast.add(String(`${keys[0]} : ${data?.res?.data[firstErrorKey][0]}`), 'error');
          }
        }
      }
    }

    if (type === 'LOD') {
      const body = {
        level: newLODName,
        free_tags: multiselectedfreeTag?.map((item) => item.id),
        new_free_tags: newFreeTag,
      };
      const data = await CallWithAuth('PATCH', LOD + id + '/update-lod/', body);
      if (data.status) {
        if (toast) {
          toast.remove('all');
          toast.add(String(data.res.data.message), 'success');
        }
        closeModal();
        dispatch(Get_All_LOD(organizationId, categoryKey, '', limit, currentPage));
        setSort('');
      } else {
        const keys = Object.keys(data.res.data);

        if (keys.length > 0) {
          const firstErrorKey = keys[0];
          if (toast) {
            toast.remove('all');
            toast.add(String(`${keys[0]} : ${data?.res?.data[firstErrorKey][0]}`), 'error');
          }
        }
      }
    }

    if (type === 'QuestionBank') {
      const hasIncompleteRow = metatags.some(
        (item) => (item.key?.trim() && !item.value?.trim()) || (!item.key?.trim() && item.value?.trim())
      );

      if (hasIncompleteRow) {
        if (toast) {
          toast.remove('all');
          toast.add(
            'Metatag Input field is empty. Please either remove both input fields or fill both the input fields.',
            'error'
          );
        }
        return;
      }

      const metatagsObject = {};
      metatags.forEach((item) => {
        if (item.key && item.key.trim() !== '') {
          let finalKey = item.key.trim();
          const keyMatch = keySuggestions.find((k) => k.toLowerCase() === finalKey.toLowerCase());
          if (keyMatch) {
            finalKey = keyMatch;
          }

          let finalValue = item.value ? item.value.trim() : '';
          const valMatch = valueSuggestions.find((v) => v.toLowerCase() === finalValue.toLowerCase());
          if (valMatch) {
            finalValue = valMatch;
          }

          metatagsObject[finalKey] = finalValue;
        }
      });

      const body = {
        name: newQuestionBankName,
        discription: newQuestionBankDescription,
        free_tags: multiselectedfreeTag?.map((item) => item.id),
        new_free_tags: newFreeTag,
        is_loft: questionBankLOFTStatus,
        metatags: metatagsObject,
      };

      const data = await CallWithAuth('PATCH', EDIT_QUESTIONBANK + id + '/update-question-bank/', body);
      if (data.status) {
        if (toast) {
          toast.remove('all');
          toast.add(String(data.res.data.message), 'success');
        }
        closeModal();
        dispatch(Get_All_Question_bank(organizationId, categoryKey, '', limit, currentPage));
        setSort('');
      } else {
        const keys = Object.keys(data.res.data);
        if (keys.length > 0) {
          const firstErrorKey = keys[0];
          if (toast) {
            toast.remove('all');
            toast.add(String(`${keys[0]} : ${data?.res?.data[firstErrorKey][0]}`), 'error');
          }
        }
      }
    }

    if (type === 'Identifier') {
      const body = {
        name: newIdentifierName,
        description: newIdentifierDescription,
        free_tags: multiselectedfreeTag?.map((item) => item.id),
        new_free_tags: newFreeTag,
      };

      const data = await CallWithAuth('PATCH', EDIT_IDENTIFIER + id + '/identifier-update/', body);
      if (data.status) {
        if (toast) {
          toast.remove('all');
          toast.add(String(data.res.data.message), 'success');
        }
        closeModal();
        dispatch(Get_All_Identifier(organizationId, categoryKey, '', limit, currentPage));
        setSort('');
      } else {
        const keys = Object.keys(data.res.data);

        if (keys.length > 0) {
          const firstErrorKey = keys[0];
          if (toast) {
            toast.remove('all');
            toast.add(String(`${keys[0]} : ${data?.res?.data[firstErrorKey][0]}`), 'error');
          }
        }
      }
    }

    if (type === 'SubjectPipeline') {
      const body = {
        subject: selectedPrimaryTag,
        area: selectedAreaTag,
        topic: selectedTopicTag,
        subtopic: multiselectedSubTopicTag?.map((item) => item).join(', '),
        subtopic_description: descriptionSubTopic,
      };

      const data = await CallWithAuth('PATCH', EDIT_SUBJECT_TAG + id + '/update-subject-tag/', body);
      if (data.status) {
        closeModal();
        dispatch(Get_All_Subject_pipeline(organizationId, categoryKey, '', limit, currentPage));
      } else {
        const keys = Object.keys(data.res.data);

        if (keys.length > 0) {
          const firstErrorKey = keys[0];
          if (toast) {
            toast.remove('all');
            toast.add(String(`${keys[0]} : ${data?.res?.data[firstErrorKey][0]}`), 'error');
          }
        }
      }
    }
  };

  useEffect(() => {
    updateFieldChanged();
  }, [data]);

  const updateFieldChanged = (rest = false) => {
    if (type === 'Category') {
      if (rest) {
        setNewCategoryName('');
        setNewCategoryDescription('');
        setmultiSelectedfreeTag([]);
      } else {
        setNewCategoryName(data?.name);
        setNewCategoryDescription(data?.description);
        setmultiSelectedfreeTag(data?.free_tags);
      }
    }
    if (type === 'LOD') {
      if (rest) {
        setNewLODName('');
        setmultiSelectedfreeTag([]);
      } else {
        setNewLODName(data?.level);
        setmultiSelectedfreeTag(data?.free_tags);
      }
    }
    if (type === 'QuestionBank') {
      if (rest) {
        setNewQuestionBankName('');
        setNewQuestionBankDescription('');
        setmultiSelectedfreeTag([]);
        setQuestionBankLOFTStatus(false);
        setMetatags([
          { key: '', value: '' },
          { key: '', value: '' },
        ]);
        setActiveKeyIndex(null);
        setActiveValueIndex(null);
      } else {
        setNewQuestionBankName(data?.name);
        setNewQuestionBankDescription(data?.discription);
        setmultiSelectedfreeTag(data?.free_tags);
        setQuestionBankLOFTStatus(data?.is_loft);

        let parsedMetatags = data?.metatags;
        if (typeof parsedMetatags === 'string') {
          try {
            parsedMetatags = JSON.parse(parsedMetatags);
          } catch (e) {
            parsedMetatags = {};
          }
        }
        if (parsedMetatags && typeof parsedMetatags === 'object' && Object.keys(parsedMetatags).length > 0) {
          const rows = Object.entries(parsedMetatags).map(([key, value]) => ({ key, value: String(value) }));
          setMetatags(rows);
        } else {
          setMetatags([
            { key: '', value: '' },
            { key: '', value: '' },
          ]);
        }
      }
    }
    if (type === 'Identifier') {
      if (rest) {
        setNewIdentifierName('');
        setNewIdentifierDescription('');
        setmultiSelectedfreeTag([]);
      } else {
        setNewIdentifierName(data?.name);
        setNewIdentifierDescription(data?.description);
        setmultiSelectedfreeTag(data?.free_tags);
      }
    }
    if (type === 'SubjectPipeline') {
      if (rest) {
        setNewQuestionBankName('');
        setNewQuestionBankDescription('');
        setQuestionBankLOFTStatus(false);
        setmultiSelectedfreeTag([]);
        setSelectedPrimaryTag('');
        setSelectedPrimaryTagStatus(false);
        setSelectedTopicTag('');
        setSelectedTopicTagStatus(false);
        setSelectedAreaTag('');
        setSelectedAreaTagStatus(false);
        setdescriptionSubTopic('');
        setmultiSelectedSubTopicTag([]);
      } else {
        setNewQuestionBankName(data?.name);
        setNewQuestionBankDescription(data?.discription);
        setmultiSelectedfreeTag(data?.free_tags);
        setSelectedPrimaryTag(data?.subject);
        setSelectedPrimaryTagStatus(true);
        setSelectedTopicTag(data?.topic);
        setSelectedTopicTagStatus(true);
        setSelectedAreaTag(data?.area);
        setSelectedAreaTagStatus(true);
        setdescriptionSubTopic(data?.subtopic_description);
        setmultiSelectedSubTopicTag(data?.subtopic.split(','));
        setQuestionBankLOFTStatus(data?.is_loft);
      }
    }
  };
  //  _____________ outside clickable close list  _____________
  const modalRef = useRef();
  //  _____________ outside clickable close modal  _____________
  const rowRef = useRef();
  return (
    <>
      {modal ? (
        <>
          {type === 'Category' ? (
            <div className={style.filterModal}>
              <div className={style.center_div} ref={modalRef}>
                <div className={style.top_title}>
                  {/* __________ close __________  */}
                  <div className={style.close}>
                    <button
                      onClick={() => {
                        closeModal();
                        updateFieldChanged();
                      }}
                    >
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M6.34375 6.34375L17.6575 17.6575"
                          stroke="#212529"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M6.34254 17.6575L17.6562 6.34375"
                          stroke="#212529"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                  </div>

                  {/* __________ title __________ */}
                  <div className={style.title} style={{ bottom: '8px' }}>
                    <div>
                      <span>Edit Category</span>
                    </div>
                  </div>
                </div>

                {/* TABLE LISTING OF ALL AND MY QUESTION  */}
                <div className={`${style.master_modal} ${style.master_modalWrap}`} style={{ width: '97%' }}>
                  <div className={style.tags}>
                    <div className={style.subject} style={{ position: 'relative', bottom: '15px' }}>
                      <p>
                        Category Name <span className={style.required_field}>*</span>
                      </p>
                      <input
                        className={style.input_search}
                        value={newCategoryName}
                        onChange={(e) => setNewCategoryName(e.target.value)}
                        type="search"
                        id="searchInput"
                        placeholder="Type Category Name"
                      />
                    </div>
                  </div>

                  <div className={style.tags}>
                    <div className={style.subject} style={{ position: 'relative', bottom: '15px' }}>
                      <p>Category Description </p>
                      <textarea
                        className={` ${style.input_search} ${style.description_input}`}
                        value={newCategoryDescription}
                        onChange={(e) => setNewCategoryDescription(e.target.value)}
                        type="textarea"
                        id="searchInput"
                        placeholder="Type Category Description"
                        style={{ width: '93.5%' }}
                      />
                    </div>
                  </div>

                  <div className={style.tags}>
                    <div className={style.subject} style={{ position: 'relative', bottom: '15px' }}>
                      <p>Tags </p>
                    </div>
                  </div>
                  <div
                    className={style.master_tag_search}
                    style={{ position: 'relative', bottom: '15px', maxWidth: 'none' }}
                  >
                    <div className={style.tag_icon}>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M11.5 18C15.0899 18 18 15.0899 18 11.5C18 7.91015 15.0899 5 11.5 5C7.91015 5 5 7.91015 5 11.5C5 15.0899 7.91015 18 11.5 18Z"
                          stroke="#212529"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M18.2598 19.2592L16.1406 16.8594"
                          stroke="#212529"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      <span>Tags</span>
                    </div>

                    {/* this is input field for searching */}
                    <div
                      className={style.input_search}
                      ref={rowRef}
                      style={{
                        overflowY: 'auto',
                        display: multiselectedfreeTag?.length > 0 || newFreeTag?.length > 0 ? 'flex' : 'block',
                        flexWrap: multiselectedfreeTag?.length > 0 || newFreeTag?.length > 0 ? 'wrap' : 'nowrap',
                      }}
                    >
                      {/* multifreeTag selected one  */}
                      {multiselectedfreeTag?.map((items, i) => (
                        <>
                          <span
                            key={i}
                            className={`${style.selected_tags} ${style.masterSelectTags}`}
                            style={{
                              maxWidth: multiselectedfreeTag?.length > 0 || newFreeTag?.length > 0 ? '600px' : 'none',
                            }}
                          >
                            {items.name}{' '}
                          </span>
                        </>
                      ))}

                      {/* new free tag selected one  */}
                      {newFreeTag?.map((items, i) => (
                        <>
                          <span
                            key={i}
                            className={`${style.selected_tags} ${style.masterSelectTags}`}
                            style={{
                              maxWidth: multiselectedfreeTag?.length > 0 || newFreeTag?.length > 0 ? '600px' : 'none',
                            }}
                          >
                            {items}{' '}
                          </span>
                        </>
                      ))}
                      {/* input field  */}
                      <input
                        type="search"
                        id="searchInput"
                        placeholder=""
                        value={multifreeTaginput}
                        onChange={(e) => TagFreeMultiple(e.target.value)}
                        style={{ padding: '15px', flex: '1', minWidth: '200px' }}
                      />
                    </div>
                    <>
                      {/* list of items of pre-defined multifree tag  */}
                      {multifreeTagStatus ? (
                        <div className={style.list_input_primary}>
                          {multifreeTag?.map((items, i) => (
                            <>
                              <div key={i} className={style.pointer} onClick={() => selectFreeTag(items)}>
                                <span>{items.name} </span>
                              </div>
                            </>
                          ))}
                        </div>
                      ) : (
                        ''
                      )}

                      {/* list of item of user-defined multifreetag  */}
                      {newfreeTagStatus ? (
                        <div className={style.list_input_primary}>
                          {newfreeTags?.map((items, i) => (
                            <>
                              <div key={i} className={style.pointer} onClick={() => selectnewFreeTag(items)}>
                                <span>{items} </span>
                              </div>
                            </>
                          ))}
                        </div>
                      ) : (
                        ''
                      )}
                    </>
                    {/* cancel button  */}
                    <div className={style.cancel_button}>
                      <button className={style.pointer} onClick={() => CancelButton()}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M7.75781 7.75781L16.2431 16.2431"
                            stroke="#272727"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M7.75691 16.2431L16.2422 7.75781"
                            stroke="#272727"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>

                  <div className={` ${style.saveButton_questionBank} ${style.margin_top_20} ${style.masterButtonWrap}`}>
                    <div className={` ${style.cancel} ${style.pointer}`} onClick={() => updateFieldChanged()}>
                      Clear
                    </div>
                    <div>
                      <button className={style.blue_button} onClick={() => AddNew(data?.id)}>
                        Save Changes
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            ''
          )}

          {type === 'Identifier' ? (
            <div className={style.filterModal}>
              <div className={style.center_div_large} ref={modalRef} style={{ overflow: 'hidden' }}>
                <div className={style.top_title}>
                  {/* __________ close __________  */}
                  <div className={style.close}>
                    <button
                      onClick={() => {
                        closeModal();
                        updateFieldChanged();
                      }}
                    >
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M6.34375 6.34375L17.6575 17.6575"
                          stroke="#212529"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M6.34254 17.6575L17.6562 6.34375"
                          stroke="#212529"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                  </div>

                  {/* __________ title __________ */}
                  <div className={style.title} style={{ position: 'relative', bottom: '5px' }}>
                    <div>
                      <span>Edit Identifier</span>
                    </div>
                  </div>
                </div>

                {/* TABLE LISTING OF ALL AND MY QUESTION  */}
                <div className={`${style.master_modal} ${style.master_modalWrap}`} style={{ width: '97%' }}>
                  <div className={style.tags}>
                    <div className={style.subject}>
                      <p>
                        Section Identifier Name <span className={style.required_field}>*</span>
                      </p>
                      <input
                        className={style.input_search}
                        value={newIdentifierName}
                        onChange={(e) => setNewIdentifierName(e.target.value)}
                        type="search"
                        id="searchInput"
                        placeholder="Type Identifier Name"
                      />
                    </div>
                  </div>

                  <div className={style.tags}>
                    <div className={style.subject}>
                      <p>Section Identifier Description </p>
                      <textarea
                        className={` ${style.input_search} ${style.description_input}`}
                        value={newIdentifierDescription}
                        onChange={(e) => setNewIdentifierDescription(e.target.value)}
                        type="textarea"
                        id="searchInput"
                        placeholder="Type Identifier Description"
                        style={{ width: '93.5%' }}
                      />
                    </div>
                  </div>
                  <div className={style.tags}>
                    <div className={style.subject} style={{ position: 'relative', top: '7px' }}>
                      <p>Tags </p>
                    </div>
                  </div>
                  <div className={style.master_tag_search} style={{ maxWidth: 'none' }}>
                    <div className={style.tag_icon}>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M11.5 18C15.0899 18 18 15.0899 18 11.5C18 7.91015 15.0899 5 11.5 5C7.91015 5 5 7.91015 5 11.5C5 15.0899 7.91015 18 11.5 18Z"
                          stroke="#212529"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M18.2598 19.2592L16.1406 16.8594"
                          stroke="#212529"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      <span>Tags</span>
                    </div>

                    {/* this is input field for searching */}
                    <div
                      className={style.input_search}
                      ref={rowRef}
                      style={{
                        overflowY: 'auto',
                        display: multiselectedfreeTag?.length > 0 || newFreeTag?.length > 0 ? 'flex' : 'block',
                        flexWrap: multiselectedfreeTag?.length > 0 || newFreeTag?.length > 0 ? 'wrap' : 'nowrap',
                      }}
                    >
                      {/* multifreeTag selected one  */}
                      {multiselectedfreeTag?.map((items, i) => (
                        <>
                          <span
                            key={i}
                            className={`${style.selected_tags} ${style.masterSelectTags}`}
                            style={{
                              maxWidth: multiselectedfreeTag?.length > 0 || newFreeTag?.length > 0 ? '600px' : 'none',
                            }}
                          >
                            {items.name}{' '}
                          </span>
                        </>
                      ))}

                      {/* new free tag selected one  */}
                      {newFreeTag?.map((items, i) => (
                        <>
                          <span
                            key={i}
                            className={`${style.selected_tags} ${style.masterSelectTags}`}
                            style={{
                              maxWidth: multiselectedfreeTag?.length > 0 || newFreeTag?.length > 0 ? '600px' : 'none',
                            }}
                          >
                            {items}{' '}
                          </span>
                        </>
                      ))}
                      {/* input field  */}
                      <input
                        type="search"
                        id="searchInput"
                        placeholder=""
                        value={multifreeTaginput}
                        style={{ padding: '15px', flex: '1', minWidth: '200px' }}
                        onChange={(e) => TagFreeMultiple(e.target.value)}
                      />
                    </div>

                    <>
                      {' '}
                      {/* list of items of pre-defined multifree tag  */}
                      {multifreeTagStatus ? (
                        <div className={style.list_input_primary}>
                          {multifreeTag?.map((items, i) => (
                            <>
                              <div key={i} className={style.pointer} onClick={() => selectFreeTag(items)}>
                                <span>{items.name} </span>
                              </div>
                            </>
                          ))}
                        </div>
                      ) : (
                        ''
                      )}
                      {/* list of item of user-defined multifreetag  */}
                      {newfreeTagStatus ? (
                        <div className={style.list_input_primary}>
                          {newfreeTags?.map((items, i) => (
                            <>
                              <div key={i} className={style.pointer} onClick={() => selectnewFreeTag(items)}>
                                <span>{items} </span>
                              </div>
                            </>
                          ))}
                        </div>
                      ) : (
                        ''
                      )}
                    </>

                    <div className={style.cancel_button}>
                      <button className={style.pointer} onClick={() => CancelButton()}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M7.75781 7.75781L16.2431 16.2431"
                            stroke="#272727"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M7.75691 16.2431L16.2422 7.75781"
                            stroke="#272727"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>

                  <div className={` ${style.saveButton_questionBank} ${style.margin_top_20} ${style.masterButtonWrap}`}>
                    <div className={` ${style.cancel} ${style.pointer}`} onClick={() => updateFieldChanged()}>
                      Clear
                    </div>
                    <div>
                      <button className={style.blue_button} onClick={() => AddNew(data?.id)}>
                        Save Changes
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            ''
          )}

          {type === 'LOD' ? (
            <div className={style.filterModal}>
              <div className={`${style.center_div} ${style.lodCenter_div}`} ref={modalRef}>
                <div className={style.top_title} style={{ height: 'auto' }}>
                  {/* __________ close __________  */}
                  <div className={style.close}>
                    <button
                      onClick={() => {
                        closeModal();
                        updateFieldChanged();
                      }}
                    >
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M6.34375 6.34375L17.6575 17.6575"
                          stroke="#212529"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M6.34254 17.6575L17.6562 6.34375"
                          stroke="#212529"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                  </div>

                  {/* __________ title __________ */}
                  <div className={style.title} style={{ bottom: '8px' }}>
                    <div>
                      <span>Edit Level of Difficulty</span>
                    </div>
                  </div>
                </div>

                {/* TABLE LISTING OF ALL AND MY QUESTION  */}
                <div className={style.master_modal} style={{ height: 'auto', width: '97%' }}>
                  <div className={style.tags}>
                    <div className={style.subject}>
                      <p>
                        Level of Difficulty Name <span className={style.required_field}>*</span>{' '}
                      </p>
                      <input
                        className={style.input_search}
                        value={newLODName}
                        onChange={(e) => setNewLODName(e.target.value)}
                        type="search"
                        id="searchInput"
                        placeholder="Type LOD Name"
                      />
                    </div>
                  </div>

                  <div className={style.tags}>
                    <div className={style.subject}>
                      <p>Tags </p>
                    </div>
                  </div>
                  <div
                    className={style.master_tag_search}
                    style={{ maxWidth: 'none', position: 'relative', bottom: '12px' }}
                  >
                    <div className={style.tag_icon}>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M11.5 18C15.0899 18 18 15.0899 18 11.5C18 7.91015 15.0899 5 11.5 5C7.91015 5 5 7.91015 5 11.5C5 15.0899 7.91015 18 11.5 18Z"
                          stroke="#212529"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M18.2598 19.2592L16.1406 16.8594"
                          stroke="#212529"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      <span>Tags</span>
                    </div>

                    {/* this is input field for searching */}
                    <div
                      className={style.input_search}
                      ref={rowRef}
                      style={{
                        overflowY: 'auto',
                        display: multiselectedfreeTag?.length > 0 || newFreeTag?.length > 0 ? 'flex' : 'block',
                        flexWrap: multiselectedfreeTag?.length > 0 || newFreeTag?.length > 0 ? 'wrap' : 'nowrap',
                      }}
                    >
                      {/* multifreeTag selected one  */}
                      {multiselectedfreeTag?.map((items, i) => (
                        <>
                          <span
                            key={i}
                            className={`${style.selected_tags} ${style.masterSelectTags}`}
                            style={{
                              maxWidth: multiselectedfreeTag?.length > 0 || newFreeTag?.length > 0 ? '600px' : 'none',
                            }}
                          >
                            {items.name}{' '}
                          </span>
                        </>
                      ))}

                      {/* new free tag selected one  */}
                      {newFreeTag?.map((items, i) => (
                        <>
                          <span
                            key={i}
                            className={`${style.selected_tags} ${style.masterSelectTags}`}
                            style={{
                              maxWidth: multiselectedfreeTag?.length > 0 || newFreeTag?.length > 0 ? '600px' : 'none',
                            }}
                          >
                            {items}{' '}
                          </span>
                        </>
                      ))}

                      {/* input field  */}
                      <input
                        type="search"
                        id="searchInput"
                        placeholder=""
                        value={multifreeTaginput}
                        style={{ padding: '15px', flex: '1', minWidth: '200px' }}
                        onChange={(e) => TagFreeMultiple(e.target.value)}
                      />
                    </div>

                    <>
                      {' '}
                      {/* list of items of pre-defined multifree tag  */}
                      {multifreeTagStatus ? (
                        <div className={style.list_input_primary}>
                          {multifreeTag?.map((items, i) => (
                            <>
                              <div key={i} className={style.pointer} onClick={() => selectFreeTag(items)}>
                                <span>{items.name} </span>
                              </div>
                            </>
                          ))}
                        </div>
                      ) : (
                        ''
                      )}
                      {/* list of item of user-defined multifreetag  */}
                      {newfreeTagStatus ? (
                        <div className={style.list_input_primary}>
                          {newfreeTags?.map((items, i) => (
                            <>
                              <div key={i} className={style.pointer} onClick={() => selectnewFreeTag(items)}>
                                <span>{items} </span>
                              </div>
                            </>
                          ))}
                        </div>
                      ) : (
                        ''
                      )}
                    </>

                    {/* cancel button  */}
                    <div className={style.cancel_button}>
                      <button className={style.pointer} onClick={() => CancelButton()}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M7.75781 7.75781L16.2431 16.2431"
                            stroke="#272727"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M7.75691 16.2431L16.2422 7.75781"
                            stroke="#272727"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>

                  <div className={` ${style.saveButton_questionBank} ${style.margin_top_20}`}>
                    <div className={` ${style.cancel} ${style.pointer}`} onClick={() => updateFieldChanged()}>
                      Clear
                    </div>
                    <div>
                      <button className={style.blue_button} onClick={() => AddNew(data?.id)}>
                        Save Changes
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            ''
          )}

          {type === 'QuestionBank' ? (
            <div className={style.filterModal}>
              <div className={style.center_div} ref={modalRef}>
                <div className={style.top_title}>
                  {/* __________ close __________  */}
                  <div className={style.close}>
                    <button
                      onClick={() => {
                        closeModal();
                        updateFieldChanged();
                      }}
                    >
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M6.34375 6.34375L17.6575 17.6575"
                          stroke="#212529"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M6.34254 17.6575L17.6562 6.34375"
                          stroke="#212529"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                  </div>

                  {/* __________ title __________ */}
                  <div className={style.title} style={{ bottom: '8px' }}>
                    <div>
                      <span>Edit Question Bank</span>
                    </div>
                  </div>
                </div>

                {/* TABLE LISTING OF ALL AND MY QUESTION  */}
                <div className={`${style.master_modal} ${style.master_modalWrap}`} style={{ gap: '0px', width: '97%' }}>
                  <div className={style.tags}>
                    <div className={style.subject} style={{ position: 'relative', bottom: '15px' }}>
                      <p>
                        Question Bank Name <span className={style.required_field}>*</span>
                      </p>
                      <input
                        className={style.input_search}
                        value={newQuestionBankName}
                        onChange={(e) => setNewQuestionBankName(e.target.value)}
                        type="search"
                        id="searchInput"
                        placeholder="Type Question Bank Name"
                      />
                    </div>
                  </div>

                  <div className={style.tags}>
                    <div className={style.subject} style={{ position: 'relative', bottom: '15px' }}>
                      <p>Question Bank Description </p>
                      <textarea
                        className={` ${style.input_search} ${style.description_input}`}
                        value={newQuestionBankDescription}
                        onChange={(e) => setNewQuestionBankDescription(e.target.value)}
                        type="textarea"
                        id="searchInput"
                        placeholder="Type Question Bank  Description"
                        style={{ width: '93.5%' }}
                      />
                    </div>
                  </div>

                  <div className={style.tags}>
                    <div className={style.subject} style={{ position: 'relative', bottom: '12px' }}>
                      <p>Tags </p>
                    </div>
                  </div>
                  <div
                    className={style.master_tag_search}
                    style={{ position: 'relative', bottom: '20px', maxWidth: 'none', marginTop: '10px' }}
                  >
                    <div className={style.tag_icon}>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M11.5 18C15.0899 18 18 15.0899 18 11.5C18 7.91015 15.0899 5 11.5 5C7.91015 5 5 7.91015 5 11.5C5 15.0899 7.91015 18 11.5 18Z"
                          stroke="#212529"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M18.2598 19.2592L16.1406 16.8594"
                          stroke="#212529"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      <span>Tags</span>
                    </div>

                    {/* this is input field for searching */}
                    <div
                      className={style.input_search}
                      ref={rowRef}
                      style={{
                        overflowY: 'auto',
                        display: multiselectedfreeTag?.length > 0 || newFreeTag?.length > 0 ? 'flex' : 'block',
                        flexWrap: multiselectedfreeTag?.length > 0 || newFreeTag?.length > 0 ? 'wrap' : 'nowrap',
                      }}
                    >
                      {/* multifreeTag selected one  */}
                      {multiselectedfreeTag?.map((items, i) => (
                        <>
                          <span
                            key={i}
                            className={`${style.selected_tags} ${style.masterSelectTags}`}
                            style={{
                              maxWidth: multiselectedfreeTag?.length > 0 || newFreeTag?.length > 0 ? '600px' : 'none',
                            }}
                          >
                            {items.name}{' '}
                          </span>
                        </>
                      ))}

                      {/* new free tag selected one  */}
                      {newFreeTag?.map((items, i) => (
                        <>
                          <span
                            key={i}
                            className={`${style.selected_tags} ${style.masterSelectTags}`}
                            style={{
                              maxWidth: multiselectedfreeTag.length > 0 || newFreeTag.length > 0 ? '600px' : 'none',
                            }}
                          >
                            {items}{' '}
                          </span>
                        </>
                      ))}

                      {/* input field  */}
                      <input
                        type="search"
                        id="searchInput"
                        placeholder=""
                        value={multifreeTaginput}
                        style={{ padding: '15px', flex: '1', minWidth: '200px' }}
                        onChange={(e) => TagFreeMultiple(e.target.value)}
                      />
                    </div>

                    <>
                      {/* list of items of pre-defined multifree tag  */}
                      {multifreeTagStatus ? (
                        <div className={style.list_input_primary}>
                          {multifreeTag?.map((items, i) => (
                            <>
                              <div key={i} className={style.pointer} onClick={() => selectFreeTag(items)}>
                                <span>{items.name} </span>
                              </div>
                            </>
                          ))}
                        </div>
                      ) : (
                        ''
                      )}

                      {/* list of item of user-defined multifreetag  */}
                      {newfreeTagStatus ? (
                        <div className={style.list_input_primary}>
                          {newfreeTags?.map((items, i) => (
                            <>
                              <div key={i} className={style.pointer} onClick={() => selectnewFreeTag(items)}>
                                <span>{items} </span>
                              </div>
                            </>
                          ))}
                        </div>
                      ) : (
                        ''
                      )}
                    </>

                    {/* cancel button  */}
                    <div className={style.cancel_button}>
                      <button className={style.pointer} onClick={() => CancelButton()}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M7.75781 7.75781L16.2431 16.2431"
                            stroke="#272727"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M7.75691 16.2431L16.2422 7.75781"
                            stroke="#272727"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                  <div className={style.checkboxtags}>
                    <label
                      className="custom-checkbox"
                      aria-label="Has LOFT"
                      style={{ position: 'relative', bottom: '3px' }}
                    >
                      <input
                        type="checkbox"
                        checked={questionBankLOFTStatus}
                        onChange={(e) => setQuestionBankLOFTStatus(e.target.checked)}
                      />
                      <span className="checkmark"></span>
                    </label>
                    <p className={style.checkboxLabel}>This question bank can be used in LOFT</p>
                  </div>

                  {/* __________ METATAGS SECTION __________ */}
                  <div className={style.metatagsSection}>
                    <div className={style.metatagsHeader}>
                      <div className={style.metatagsTitleWrapper}>
                        <p className={style.metatagsTitle}>Metatags</p>
                        <span className={style.metatagsSubtitle}>Custom key-value attributes</span>
                      </div>
                      <button
                        type="button"
                        className={style.addMetatagBtn}
                        onClick={handleAddMetatagRow}
                        title="Add key-value pair"
                      >
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M12 5V19M5 12H19"
                            stroke="currentColor"
                            strokeWidth="2.2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        <span>Add Metatag</span>
                      </button>
                    </div>

                    <div className={style.metatagsCard}>
                      <div className={style.metatagsColHeaders}>
                        <span className={style.metatagsColHeader}>Key</span>
                        <span className={style.metatagsColHeader}>Value</span>
                        <span className={style.metatagsColHeaderAction}></span>
                      </div>

                      <div className={style.metatagsContainer}>
                        {metatags.map((item, index) => (
                          <div key={index} className={style.metatagRow}>
                            {/* Key Input & Suggestions Dropdown */}
                            <div className={style.metatagInputWrapper}>
                              <input
                                type="text"
                                className={style.metatagInput}
                                placeholder="e.g. CyoqEligible"
                                value={item.key}
                                onFocus={() => fetchKeySuggestions(index, item.key)}
                                onChange={(e) => handleMetatagKeyChange(index, e.target.value)}
                                onBlur={() => handleKeyBlur(index)}
                              />
                              {activeKeyIndex === index && (
                                <div className={style.suggestionDropdown}>
                                  {keySuggestions
                                    .filter((k) => !item.key || k.toLowerCase().includes(item.key.toLowerCase()))
                                    .map((k, i) => (
                                      <div
                                        key={i}
                                        className={style.suggestionItem}
                                        onMouseDown={(e) => {
                                          e.preventDefault();
                                          handleSelectKey(index, k);
                                        }}
                                      >
                                        <svg
                                          width="12"
                                          height="12"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="#64748b"
                                          strokeWidth="2"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          style={{ marginRight: '6px' }}
                                        >
                                          <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path>
                                          <line x1="7" y1="7" x2="7.01" y2="7"></line>
                                        </svg>
                                        <span>{k}</span>
                                      </div>
                                    ))}
                                  {item.key &&
                                    !keySuggestions.some((k) => k.toLowerCase() === item.key.toLowerCase()) && (
                                      <div
                                        className={`${style.suggestionItem} ${style.createOption}`}
                                        onMouseDown={(e) => {
                                          e.preventDefault();
                                          handleSelectKey(index, item.key);
                                        }}
                                      >
                                        <strong>{item.key}</strong>
                                      </div>
                                    )}
                                </div>
                              )}
                            </div>

                            {/* Value Input & Suggestions Dropdown */}
                            <div className={style.metatagInputWrapper}>
                              <input
                                type="text"
                                className={style.metatagInput}
                                placeholder="e.g. true"
                                value={item.value}
                                onFocus={() => fetchValueSuggestions(index, item.value)}
                                onChange={(e) => handleMetatagValueChange(index, e.target.value)}
                                onBlur={() => handleValueBlur(index)}
                              />
                              {activeValueIndex === index && (
                                <div className={style.suggestionDropdown}>
                                  {valueSuggestions
                                    .filter((v) => !item.value || v.toLowerCase().includes(item.value.toLowerCase()))
                                    .map((v, i) => (
                                      <div
                                        key={i}
                                        className={style.suggestionItem}
                                        onMouseDown={(e) => {
                                          e.preventDefault();
                                          handleSelectValue(index, v);
                                        }}
                                      >
                                        <span>{v}</span>
                                      </div>
                                    ))}
                                  {item.value &&
                                    !valueSuggestions.some((v) => v.toLowerCase() === item.value.toLowerCase()) && (
                                      <div
                                        className={`${style.suggestionItem} ${style.createOption}`}
                                        onMouseDown={(e) => {
                                          e.preventDefault();
                                          handleSelectValue(index, item.value);
                                        }}
                                      >
                                        <strong>{item.value}</strong>
                                      </div>
                                    )}
                                </div>
                              )}
                            </div>

                            {/* Delete Row Button */}
                            <button
                              type="button"
                              className={style.deleteMetatagBtn}
                              onClick={() => handleDeleteMetatagRow(index)}
                              title="Delete pair"
                            >
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M3 6H5H21"
                                  stroke="#ef4444"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z"
                                  stroke="#ef4444"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M10 11V17"
                                  stroke="#ef4444"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M14 11V17"
                                  stroke="#ef4444"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </button>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className={` ${style.saveButton_questionBank} ${style.margin_top_20} ${style.masterButtonWrap}`}>
                    <div className={` ${style.cancel} ${style.pointer}`} onClick={() => updateFieldChanged()}>
                      Clear
                    </div>
                    <div>
                      <button className={style.blue_button} onClick={() => AddNew(data?.id)}>
                        Save Changes
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            ''
          )}

          {type === 'SubjectPipeline' ? (
            <div className={style.filterModal}>
              <div className={style.center_div_large} ref={modalRef}>
                <div className={style.top_title}>
                  {/* __________ close __________  */}
                  <div className={style.close}>
                    <button
                      onClick={() => {
                        closeModal();
                        updateFieldChanged();
                      }}
                    >
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M6.34375 6.34375L17.6575 17.6575"
                          stroke="#212529"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M6.34254 17.6575L17.6562 6.34375"
                          stroke="#212529"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                  </div>

                  {/* __________ title __________ */}
                  <div className={style.title}>
                    <div>
                      <span>Edit Subject Tag</span>
                    </div>
                  </div>
                </div>

                {/* TABLE LISTING OF ALL AND MY QUESTION  */}
                <div className={style.identifier_master_modal}>
                  <div className={style.master_modal}>
                    {/* ___________________ subject ___________________ */}
                    <div className={style.tags}>
                      <div className={style.subject}>
                        <p>Subject </p>
                      </div>
                    </div>
                    <div className={style.master_tag_search}>
                      {/* this is input field for searching */}
                      <div className={style.input_search} ref={rowRef}>
                        {selectedPrimaryTagStatus ? (
                          <span style={{ paddingLeft: '0px' }}>{selectedPrimaryTag} </span>
                        ) : (
                          <input
                            type="search"
                            id="searchInput"
                            placeholder="Type Subject"
                            onChange={(e) => TagSubject(e.target.value)}
                          />
                        )}

                        {subjectTagStatus ? (
                          <div className={style.list_input_primary}>
                            {subjectTag?.map((items, i) => (
                              <>
                                <div key={i} className={style.pointer} onClick={() => selectPrimaryTag(items)}>
                                  <span>{items} </span>
                                </div>
                              </>
                            ))}
                          </div>
                        ) : (
                          ''
                        )}
                      </div>

                      {/* cancel button  */}
                      <div className={style.cancel_button}>
                        <button className={style.pointer} onClick={() => setSelectedPrimaryTagStatus(false)}>
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7.75781 7.75781L16.2431 16.2431"
                              stroke="#272727"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M7.75691 16.2431L16.2422 7.75781"
                              stroke="#272727"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>

                    {/* ___________________ Topic ___________________ */}
                    <div className={style.tags}>
                      <div className={style.subject}>
                        <p>Topic </p>
                      </div>
                    </div>
                    <div className={style.master_tag_search}>
                      {/* this is input field for searching */}
                      <div className={style.input_search} ref={rowRef}>
                        {selectedTopicTagStatus ? (
                          <span style={{ paddingLeft: '0px' }}> {selectedTopicTag} </span>
                        ) : (
                          <input
                            type="search"
                            id="searchInput"
                            placeholder="Type Topic"
                            onChange={(e) => TagTopic(e.target.value)}
                          />
                        )}

                        {TopicTagStatus ? (
                          <div className={style.list_input_primary}>
                            {TopicTag?.map((items, i) => (
                              <>
                                <div key={i} className={style.pointer} onClick={() => selectTopicTag(items)}>
                                  <span> {items} </span>
                                </div>
                              </>
                            ))}
                          </div>
                        ) : (
                          ''
                        )}
                      </div>

                      {/* cancel button  */}
                      <div className={style.cancel_button}>
                        <button className={style.pointer} onClick={() => setSelectedTopicTagStatus(false)}>
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7.75781 7.75781L16.2431 16.2431"
                              stroke="#272727"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M7.75691 16.2431L16.2422 7.75781"
                              stroke="#272727"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className={style.master_modal}>
                    {/* ___________________ area ___________________ */}
                    <div className={style.tags}>
                      <div className={style.subject}>
                        <p>Area </p>
                      </div>
                    </div>
                    <div className={style.master_tag_search}>
                      {/* this is input field for searching */}
                      <div className={style.input_search} ref={rowRef}>
                        {selectedAreaTagStatus ? (
                          <span style={{ paddingLeft: '0px' }}> {selectedAreaTag} </span>
                        ) : (
                          <input
                            type="search"
                            id="searchInput"
                            placeholder="Type Area"
                            onChange={(e) => TagArea(e.target.value)}
                          />
                        )}

                        {AreaTagStatus ? (
                          <div className={style.list_input_primary}>
                            {AreaTag?.map((items, i) => (
                              <>
                                <div key={i} className={style.pointer} onClick={() => selectAreaTag(items)}>
                                  <span> {items} </span>
                                </div>
                              </>
                            ))}
                          </div>
                        ) : (
                          ''
                        )}
                      </div>

                      {/* cancel button  */}
                      <div className={style.cancel_button}>
                        <button className={style.pointer} onClick={() => setSelectedAreaTagStatus(false)}>
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7.75781 7.75781L16.2431 16.2431"
                              stroke="#272727"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M7.75691 16.2431L16.2422 7.75781"
                              stroke="#272727"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>

                    {/* ___________________ subtopic ___________________ */}
                    <div className={style.tags}>
                      <div className={style.subject}>
                        <p>Sub-Topic </p>
                      </div>
                    </div>
                    <div className={style.master_tag_search}>
                      {/* this is input field for searching */}
                      <div className={style.input_search} ref={rowRef}>
                        {/* multifreeTag selected one  */}
                        {multiselectedSubTopicTag?.map((items, i) => (
                          <>
                            <span key={i} className={style.selected_tags}>
                              {items}{' '}
                            </span>
                          </>
                        ))}
                        <input
                          type="search"
                          id="searchInput"
                          placeholder=""
                          value={multiSubTopicTaginput}
                          onChange={(e) => TagSubTopicMultiple(e.target.value)}
                        />

                        {/* list of items of pre-defined multiSubTopic tag  */}
                        {multiSubTopicTagStatus ? (
                          <div className={style.list_input_primary}>
                            {multiSubTopicTag?.map((items, i) => (
                              <>
                                <div key={i} className={style.pointer} onClick={() => selectSubTopicTag(items)}>
                                  <span>{items} </span>
                                </div>
                              </>
                            ))}
                          </div>
                        ) : (
                          ''
                        )}
                      </div>

                      {/* cancel button  */}
                      <div className={style.cancel_button}>
                        <button className={style.pointer} onClick={() => CancelButtonSubTopic()}>
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7.75781 7.75781L16.2431 16.2431"
                              stroke="#272727"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M7.75691 16.2431L16.2422 7.75781"
                              stroke="#272727"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div>
                  <div className={style.master_modal}>
                    {/* ___________________ Sub-top-description ___________________ */}
                    <div className={style.tags}>
                      <div className={style.subject}>
                        <p>Description of subtopic </p>
                      </div>
                    </div>
                    <div className={style.master_tag_search}>
                      {/* this is input field for searching */}
                      <div className={style.input_search} ref={rowRef}>
                        <input
                          type="text"
                          id="searchInput"
                          value={descriptionSubTopic}
                          placeholder="Type Description Of Subtopic"
                          onChange={(e) => setdescriptionSubTopic(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div>
                  <div className={style.master_modal}>
                    {/* ___________________ tags ___________________ */}
                    <div className={style.tags}>
                      <div className={style.subject}>
                        <p>Tags </p>
                      </div>
                    </div>
                    <div>
                      {multiselectedSubTopicTag?.map((items, i) => (
                        <>
                          <span key={i} className={style.slugs_Tag}>
                            {selectedPrimaryTag} | {selectedAreaTag} | {selectedTopicTag} | {items}
                          </span>{' '}
                          &nbsp;
                        </>
                      ))}
                    </div>
                  </div>
                </div>

                <div className={` ${style.saveButton_questionBank} ${style.margin_top_20} ${style.identifier_save}`}>
                  <div className={` ${style.cancel} ${style.pointer}`} onClick={() => updateFieldChanged()}>
                    Cancel
                  </div>
                  <div>
                    <button className={style.blue_button} onClick={() => AddNew(data?.id)}>
                      Save Changes
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            ''
          )}
        </>
      ) : (
        ''
      )}
    </>
  );
};

MastersEditModal.propTypes = {
  categoryKey: PropTypes.any,
  closeModal: PropTypes.func,
  currentPage: PropTypes.any,
  data: PropTypes.shape({
    area: PropTypes.any,
    description: PropTypes.any,
    discription: PropTypes.any,
    free_tags: PropTypes.any,
    id: PropTypes.any,
    level: PropTypes.any,
    name: PropTypes.any,
    res: PropTypes.shape({
      data: PropTypes.shape({
        length: PropTypes.number,
        message: PropTypes.any,
      }),
      status: PropTypes.number,
    }),
    status: PropTypes.any,
    subject: PropTypes.any,
    subtopic: PropTypes.shape({
      split: PropTypes.func,
    }),
    subtopic_description: PropTypes.any,
    topic: PropTypes.any,
  }),
  limit: PropTypes.any,
  modal: PropTypes.any,
  setSort: PropTypes.func,
  type: PropTypes.string,
};

export default MastersEditModal;
